// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 9224) return "static/chunks/9224-3119bd26293855ef.js";
	if (chunkId === 8004) return "static/chunks/8004-ca1150900513be67.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2730":"e53f8bdeee58fa38","6834":"bcf66c835890ea02"}[chunkId] + ".js";
};